export default __webpack_public_path__ + "static/media/wTop_3_p1.e7a8f667.jpeg";